/*eslint-disable no-script-url*/
import React, { Component } from 'react';
import Footer from '../components/Footer';
import IntroduceTopMenu from '../components/IntroduceTopMenu';

class Introduce03 extends Component {
  render() {
    return (
      <div>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap"  className="div-cont" >
              <div id="contents">
                <div className="app-header">
                  <p className="app-logo" onClick={() => {window.location.href = '/'}}><span className="blind">TOZ StudyCenter</span></p>
                  <a href="/introduce" className="app-close"><span className="blind">닫기</span></a>
                </div>

                <div className="info-cont">

                  <IntroduceTopMenu link={this.props.location.pathname} />

                  <div className="info-vis img03">
                    <p className="btxt">
                      토즈 스터디센터에 문의를 하시거나<br/>
                      방문하시면 <strong>무료체험과 등록</strong>에 대한<br/>
                      <strong>상세 안내</strong>를 받으실 수 있습니다.
                    </p>
                    <p className="ctxt">Since 2010</p>
                  </div>

                  <div className="info-regist-order">
                    <p className="tit"><strong>신규 회원</strong> 등록 순서</p>
                    <ul className="list">
                      <li>
                        <p className="num">01</p>
                        <p className="btxt">공간/시설/요금 안내</p>
                        <p className="stxt">학습공간과 편의시설을 직접 보시고 결정 할 수 있습니다.</p>
                      </li>
                      <li>
                        <p className="num">02</p>
                        <p className="btxt">좌석 선택</p>
                        <p className="stxt">고정석, 자유석 중 원하시는 좌석 유형을 직접 선택 할 수 있습니다.</p>
                      </li>
                      <li>
                        <p className="num">03</p>
                        <p className="btxt">유의사항 안내 및 신청서 작성</p>
                        <p className="stxt">지점 이용 시 유의사항을 듣고 신청서를 작성 해주세요.</p>
                      </li>
                      <li>
                        <p className="num">04</p>
                        <p className="btxt">나의 학습유형 체크</p>
                        <p className="stxt">자신에게 꼭 맞는 학습 유형을 확인해보세요. (무료진행)</p>
                      </li>
                      <li>
                        <p className="num">05</p>
                        <p className="btxt">이용 가이드 수신</p>
                        <p className="stxt">지점 이용과 더불어 토즈를 보다 스마트하게 이용 해보세요.</p>
                      </li>
                    </ul>
                  </div>

                </div>

                <Footer />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Introduce03;